var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2286",
    "data-name": "Group 2286",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    d: "M0,0H26V26H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M4.167,5.167V20.333H21.5V5.167ZM3.083,3h19.5a1.083,1.083,0,0,1,1.083,1.083V21.417A1.083,1.083,0,0,1,22.583,22.5H3.083A1.083,1.083,0,0,1,2,21.417V4.083A1.083,1.083,0,0,1,3.083,3Zm12.776,7.359L13.917,8.417h5.417v5.417l-1.942-1.942L13.2,16.077l-2.3-2.3L7.842,16.843,6.311,15.311l4.6-4.6,2.3,2.3Z",
    transform: "translate(0.167 0.25)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundIcon);
export default __webpack_public_path__ + "static/media/fund-icon.fe48f32d911f07266013adfd2b95a403.svg";
export { ForwardRef as ReactComponent };